<template lang="pug">
  #app.app
    Header(:backButton="isShowBackButton")
    .main(ref="main")
      transition(:name="transitionName" mode="out-in")
        keep-alive(include="Home")
          router-view
    Footer
    PortalTarget(name="photoswipe" multiple)
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import {PortalTarget} from 'portal-vue'

export default {
  name: "App",
  components: {
    Header,
    Footer,
    PortalTarget
  },
  data() {
    return {
      transitionName: "",
      isShowBackButton: false,
    };
  },

  async beforeCreate() {
    this.$router.afterEach((to) => {
      this.transitionName = to.meta.transitionName;
      this.isShowBackButton = to.meta?.isShowBackButton ?? true;
    });

    await this.$store.dispatch('fetchData');
  },
};
</script>

<style lang="scss">
.slide-left-enter {
  transform: scale(1.02);
  opacity: 0;
}

.slide-left-enter-to {
  transform: scale(1);
  opacity: 1;
}

.slide-left-enter-active {
  transition: all 0.2s ease;
}


.slide-left-leave {
  opacity: 1;
}

.slide-left-leave-to {
  opacity: 0;
}

.slide-left-leave-active {
  transition: all 0.2s ease;
}

////////////////////////////////

.slide-right-enter {
  transform: scale(0.98);
  opacity: 0;
}

.slide-right-enter-to {
  transform: scale(1);
  opacity: 1;
}

.slide-right-enter-active {
  transition: all 0.2s ease;
}


.slide-right-leave {
  opacity: 1;
}

.slide-right-leave-to {
  opacity: 0;
}

.slide-right-leave-active {
  transition: all 0.2s ease;
}
</style>
